import React, {FC} from 'react';

import {MacrosBannerState} from '../../../../store/panels/app/banners/bannersState';
import {MacrosSuccessBanner} from './macrosSuccessBanner';

/*
 * Props.
 */

interface MacrosBannersProps {
  banners: ReadonlyArray<MacrosBannerState>;
  onClose: (bannerUid: string) => void;
}

/*
 * Component.
 */
// In the future with more banner types we can add a switch or something to render different types of banners
export const MacrosBanners: FC<MacrosBannersProps> = ({banners, onClose}) =>
  banners.map((banner) => (
    <MacrosSuccessBanner key={banner.uid} name={banner.name} onDismissClick={() => onClose(banner.uid)} />
  ));
